import {
  GenericApiResponse,
  ProducStock,
  ProductCreateI,
  ProductListExist,
  ProductListI,
  ProductsByWarehouse,
} from "interfaces";
import { StringDecoder } from "node:string_decoder";
import { get, patch, post, remove } from "services/services.methods";
import {
  ProductExistPaths,
  ProductExistReportPaths,
  ProductsPaths,
  Reports,
} from "services/services.paths";

export const getProducts = async () => {
  const response = await get<ProductListI[]>(ProductsPaths.get);

  return response.data;
};

export const getgetProductsSelect = async () => {
  const response = await get<ProductListI[]>(ProductsPaths.get);

  return response;
};

export const getProductsExist = async () => {
  const response = await get<ProductListI[]>(ProductExistPaths.get);

  return response.data;
};

export const getExistReport = async (purchaseParams: {
  productId: number;
  warehouseId: number;
}): Promise<GenericApiResponse<ProductListExist[]>> => {
  const url = `${ProductExistReportPaths.post}?productId =${purchaseParams.productId}&warehouseId=${purchaseParams.warehouseId} }`;
  const response = await post<ProductListExist[]>(
    ProductExistReportPaths.post,
    purchaseParams
  );

  return response;
};

export const deleteProduct = async (id: string) => {
  const response = await remove<any>(ProductsPaths.delete + `/${id}`);

  return response;
};

export const editProduct = async (id: any, data: ProductCreateI) => {
  const response = await patch<any>(`${ProductsPaths.put}/${id}`, data);
  return response;
};

export const createProduct = async (prodcut: ProductCreateI) => {
  const response = await post<any>(ProductsPaths.post, prodcut);

  return response;
};

export const getProductsByWarehouse = async (warehouseId: string) => {
  const response = await get<ProductsByWarehouse[]>(
    ProductsPaths.getByWarehouse + `/${warehouseId}`
  );

  return response.data;
};

export const getProductsReport = async (fechaInicial: string, fechaFinal: string) => {
  const response = await get<any[]>(
    `${Reports.getArticleReport}/${fechaInicial}/${fechaFinal}`
  );

  return response;
};

// export const getProductsReport = async (
//   startDate: string,
//   endDate: string
// ): Promise<any[]> => {
//   const response = await get<any[]>(
//     `${ProductExistPaths.get}/${endDate}/${startDate}`
//   );
//   return response.data;
// };
